import * as icons from "../../utils/icons";
import * as mdiPaths from "@mdi/js";
import MdiReactIcon from "@mdi/react";
import { Colors } from "../../utils/style/colors";

// "mdi:phone-alert" -> "mdiPhoneAlert"
const toMdiKey = (name) =>
  "mdi" +
  name
    .replace(/^mdi:/, "")
    .split("-")
    .filter(Boolean)
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
    .join("");

// Map color="action" etc. the way icons.js does.
const mapColor = (color) => {
  if (color === "action") return Colors.actionIcon;
  if (color === "primary") return Colors.primary();
  if (color === "inherit") return undefined;
  return color;
};

// Resolve a backend icon string to a component: repo export names ("SoundIcon")
// or "mdi:kebab-case". Returns null when unresolved.
export const resolveSettingIcon = (name) => {
  if (!name || typeof name !== "string") return null;

  if (name.startsWith("mdi:")) {
    const path = mdiPaths[toMdiKey(name)];
    if (!path) return null;
    const SettingMdiIcon = ({ color, size = 0.8, ...rest }) => (
      <MdiReactIcon path={path} size={size} color={mapColor(color)} {...rest} />
    );
    return SettingMdiIcon;
  }

  return icons[name] || null;
};
